var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVegan = function SvgVegan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vegan-icon-group",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vegan-icon-wrapper",
    transform: "translate(-109.000000, -211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-vegan",
    transform: "translate(69.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.000000, 2.000000)",
    id: "Vegan",
    fill: "#1E9336",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,24 C5.372583,24 -3.78367554e-15,18.627417 -3.78367554e-15,12 C-3.78367554e-15,5.372583 5.372583,-3.78367554e-15 12,-3.78367554e-15 C18.627417,-3.78367554e-15 24,5.372583 24,12 C23.9926632,18.6243756 18.6243756,23.9926632 12,24 Z M12,0.950521411 C5.89754148,0.950521411 0.950521411,5.89754148 0.950521411,12 C0.950521411,18.1024585 5.89754148,23.0494786 12,23.0494786 C18.1024585,23.0494786 23.0494786,18.1024585 23.0494786,12 C23.0436075,5.89997501 18.100025,0.956392469 12,0.950521411 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "5.87619259 4.960284 8.4375416 4.960284 11.9707122 16.1002884 12 16.1002884 15.6183714 4.960284 18.1238074 4.960284 13.3099623 19.039716 10.5702241 19.039716"
  })))))));
};
export default SvgVegan;